import translate from '@translate';
import React, { FC, useEffect, useState } from 'react';
import Grid, { GridItem } from 'src/components/Grid';
import Select, { OptionType, SelectValueType } from 'src/components/Select';
import TextField from 'src/components/TextField';
import { UserType } from 'src/types/user';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { RoleType } from 'src/types/role';
import { FormErrorsType, OnChangeType } from '../../types/global';
import { EditKeysType } from './constants';

export interface DetailPropsType {
    onChange: OnChangeType<EditKeysType>;
    editData: UserType;
    editErrors: FormErrorsType;
    newUser: boolean;
    disableEdit: boolean;
    boolNumberCodes: ConstantsCodeType[];
    loggedSkladonUser?: number;
    rolesApprovedData?: RoleType[] | null;
    data: UserType | null;
    showAllProvidersField?: boolean;
    allProviders?: number;
    allProvidersFieldDisabled?: boolean;
    onChangeAllProviders?: (value: SelectValueType | SelectValueType[], error: boolean) => void;
}

const Detail: FC<DetailPropsType> = (props) => {
    const [roleOptions, setRoleOptions] = useState<OptionType[]>([]);

    const handleChangeRole = (value: SelectValueType | SelectValueType[], error: boolean) => {
        if (!props.rolesApprovedData || Array.isArray(value)) {
            return;
        }
        const selectedRole = props.rolesApprovedData.find((role) => role.ID_ROLE == value);
        props.onChange('roles', selectedRole ? [selectedRole] : [], error);
    };

    useEffect(() => {
        if (props.rolesApprovedData) {
            setRoleOptions(
                props.rolesApprovedData.map((role) => ({
                    label: role.ROLE_NAME || '',
                    value: role.ID_ROLE || -1,
                }))
            );
        }
    }, [props.rolesApprovedData]);

    return (
        <Grid>
            <GridItem cols={3}>
                <TextField
                    value={props.editData.NAME}
                    error={props.editErrors.NAME}
                    onChange={(value, error) => props.onChange('NAME', value, error)}
                    name="NAME"
                    label={translate('userDetail.name')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={3}>
                <TextField
                    value={props.editData.SURNAME}
                    error={props.editErrors.SURNAME}
                    onChange={(value, error) => props.onChange('SURNAME', value, error)}
                    name="SURNAME"
                    label={translate('userDetail.surname')}
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={3}>
                <TextField
                    value={props.editData.USER_EMAIL}
                    error={props.editErrors.USER_EMAIL}
                    onChange={(value, error) => props.onChange('USER_EMAIL', value, error)}
                    name="USER_EMAIL"
                    label={translate('userDetail.email')}
                    type="email"
                    fullWidth
                    required
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={3}>
                <TextField
                    value={props.editData.PHONE}
                    error={props.editErrors.PHONE}
                    onChange={(value, error) => props.onChange('PHONE', value || '', error)}
                    name="PHONE"
                    label={translate('userDetail.phone')}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={3}>
                <Select
                    options={roleOptions}
                    value={props.editData.roles?.[0]?.ID_ROLE}
                    error={props.editErrors.roles}
                    onChange={(value, error) => handleChangeRole(value, error)}
                    name="roles"
                    label={translate('userDetail.roles')}
                    required={!!roleOptions.length && (!!props.newUser || !!props.data?.roles?.length)}
                    fullWidth
                    disabled={props.disableEdit}
                />
            </GridItem>
            <GridItem cols={3}>
                {!props.newUser && (
                    <TextField
                        label={translate('userDetail.active')}
                        value={props.boolNumberCodes.find((item) => item.value === props.editData.active || 0)?.label}
                        name="active"
                        fullWidth
                        disabled
                    />
                )}
            </GridItem>

            <GridItem cols={3}>
                {!!props.loggedSkladonUser && (
                    <Select
                        options={props.boolNumberCodes}
                        value={props.editData.SKLADON_USER}
                        error={props.editErrors.SKLADON_USER}
                        onChange={(value, error) => props.onChange('SKLADON_USER', value, error)}
                        name="SKLADON_USER"
                        label={translate('userDetail.skladonUser')}
                        fullWidth
                        required
                        disabled={props.disableEdit}
                    />
                )}
            </GridItem>
            {props.showAllProvidersField && (
                <GridItem cols={3}>
                    <Select
                        label={translate('userDetail.allProviders')}
                        value={props.allProviders}
                        options={props.boolNumberCodes}
                        onChange={props.onChangeAllProviders}
                        name="allProviders"
                        disabled={props.allProvidersFieldDisabled}
                        fullWidth
                        required
                    />
                </GridItem>
            )}
        </Grid>
    );
};

export default Detail;
